// extracted by mini-css-extract-plugin
export default {"root":"QueryForm_root__gNU4r","search":"QueryForm_search__0uzIN","rig":"QueryForm_rig__z4VvH"};